import { FunctionComponent, useEffect } from 'react';
import { ConfirmationTemplate, InternalServerErrorTemplate } from '@templates';
import { useLocation } from 'react-router-dom';
import { RoutesList } from '../../../routes/Routes';
import { useBuskingStore } from '../../../../hooks/useBuskingStore';
import { conditionsMap, contents } from '@shared/constants';
import { ConditionalText } from '@shared/components';

export const Confirmation: FunctionComponent = () => {
  const location = useLocation();
  const { reset, get } = useBuskingStore();
  const confirmation = get('confirmation');

  const redirectionLink = 'https://www.westminster.gov.uk';

  const resetDataAndRedirect = () => {
    if (location.pathname === RoutesList.CONFIRMATION) {
      reset();
      window.location.href = redirectionLink;
    }
  };

  useEffect(() => {
    window.addEventListener('popstate', resetDataAndRedirect, {
      once: true,
    });
  });

  if (confirmation?.case_reference !== undefined) {
    localStorage.removeItem('busking-store');
  } else {
    return <InternalServerErrorTemplate />;
  }

  const contentTitle = 'What happens next?';

  const navigationButton = {
    label: 'Return to homepage',
    isExternalLink: true,
    onClick: () => {
      resetDataAndRedirect();
      if (redirectionLink !== undefined) {
        window.location.href = redirectionLink;
      }
    },
  };

  const getCondition = () => {
    const canSendEmail =
      get('receiveConfirmationEmail').toLowerCase() === 'yes';
    const canContact = get('contactUserOption').toLowerCase() === 'yes';
    const issueHappeningNow =
      get('isIssueHappeningNow').toLowerCase() === 'yes';

    const key =
      `${canSendEmail}-${canContact}-${issueHappeningNow}` as keyof typeof conditionsMap;
    return (conditionsMap[key] as keyof typeof contents) || 'defaultCondition';
  };

  const contentSubtext = (
    <ConditionalText
      condition={getCondition()}
      reviewTime={confirmation.sla_text.toLocaleLowerCase()}
    />
  );
  return (
    <ConfirmationTemplate
      reference={confirmation?.case_reference}
      contentTitle={contentTitle}
      contentSubtext={contentSubtext}
      feedbackLink
      button={navigationButton}
    />
  );
};
